import { render, staticRenderFns } from "./AdUnit.vue?vue&type=template&id=050179ce&scoped=true&"
import script from "./AdUnit.vue?vue&type=script&lang=js&"
export * from "./AdUnit.vue?vue&type=script&lang=js&"
import style0 from "./AdUnit.vue?vue&type=style&index=0&id=050179ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050179ce",
  null
  
)

export default component.exports